import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/location",

        async loadTimezones() {
            const url = this.url("/timezone");
            return await Vue.http.get(url);
        }
    },
    base
);
